import { to2cs3ny02qtbcb as to } from '../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  FontDirect3ifj3qs5hfije as FontDirect,
  Font1uq8v2r7qm3xe as Font,
  ImageResource1861inqz1dzjl as ImageResource,
} from '../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ResourcesClass;
function Resources() {
  if (ResourcesClass === VOID) {
    class $ {
      constructor() {
        Resources_instance = this;
        var tmp = this;
        var tmp_0 = mapOf(to(400, 'common/fonts/Montserrat.ttf'));
        // Inline function 'kotlin.collections.mapOf' call
        var tmp$ret$0 = emptyMap();
        tmp.tf8_1 = new (Font())('fontsMontserrat', VOID, VOID, new (FontDirect())(tmp_0, tmp$ret$0));
        var tmp_1 = this;
        var tmp_2 = mapOf(to(400, 'common/fonts/Montserrat-Bold.ttf'));
        // Inline function 'kotlin.collections.mapOf' call
        var tmp$ret$1 = emptyMap();
        tmp_1.uf8_1 = new (Font())('fontsMontserratBold', VOID, VOID, new (FontDirect())(tmp_2, tmp$ret$1));
        var tmp_3 = this;
        var tmp_4 = mapOf(to(400, 'common/fonts/Roboto-Regular.ttf'));
        // Inline function 'kotlin.collections.mapOf' call
        var tmp$ret$2 = emptyMap();
        tmp_3.vf8_1 = new (Font())('fontsRobotoRegular', VOID, VOID, new (FontDirect())(tmp_4, tmp$ret$2));
        this.wf8_1 = new (ImageResource())('common/images/Full_Logo_Black.webp');
        this.xf8_1 = new (ImageResource())('common/images/Full_Logo_Color.webp');
        this.yf8_1 = new (ImageResource())('common/images/Full_Logo_Color_Large.png');
        this.zf8_1 = new (ImageResource())('common/images/Logo_Color.webp');
        this.af9_1 = new (ImageResource())('common/images/New Activity Icon.png');
        this.bf9_1 = new (ImageResource())('common/images/scope_legend.png');
      }
    }
    initMetadataForObject($, 'Resources');
    ResourcesClass = $;
  }
  return ResourcesClass;
}
var Resources_instance;
function Resources_getInstance() {
  if (Resources_instance === VOID)
    new (Resources())();
  return Resources_instance;
}
//region block: exports
export {
  Resources_getInstance as Resources_getInstance2tvlmekcueurd,
};
//endregion

//# sourceMappingURL=Resources.js.mjs.map
